<template>
  <div class="container box">
    <br>
    <h2>Données du profil</h2>
    <br>
    <!--<p>{{token}}</p>-->
    <div>
      <table class="table-user center-margin">
        <tr>
          <td>Mail/Login :</td>
          <td>{{ token.login }}</td>
        </tr>
        <tr>
          <td>Prenom :</td>
          <td>{{ token.prenom }}</td>
        </tr>
        <tr>
          <td>Nom :</td>
          <td>{{ token.nom }}</td>
        </tr>
        <tr>
          <td>Poste :</td>
          <td>{{ token.poste }}</td>
        </tr>
        <tr>
          <td>Departement :</td>
          <td>{{ token.departement }}</td>
        </tr>
        <tr>
          <td>Extras :</td>
          <td>Code tiers : {{ codeTiers }}, code pec : {{ codePec }}</td>
        </tr>
        <tr>
          <td>Roles :</td>
          <td>{{ roles }}</td>
        </tr>
        <tr>
          <td>Prochaine reconnexion :</td>
          <td>{{ time(token.exp) }}</td>
        </tr>
        <tr>
          <td>Activer les appels masqués :</td>
          <td>
              <toggle-button v-model="maskedCallOption" :font-size="15" :height="20" :width="70"
                             :labels="{unchecked: 'Non', checked: 'Oui'}"  />
          </td>
        </tr>
        <tr v-show="patrimoine">
          <td>Patrimoine :</td>
          <td>
              <ul>
                <li v-for="p in patrimoine" :key="p.id">
                  {{p.poste}} dans {{p.entree}}
                </li>
              </ul>
          </td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import timestampTranslation from "../js/timestampTranslation";

export default {
  name: "UserProfile",
  computed: {
    ...mapGetters('user', ['getDecodedToken', 'getCodeTiers', 'getCodePec', 'getRoles', 'getOptions']),
    ...mapGetters('partenaires', ['partenaires']),
    token() {
      return this.getDecodedToken
    },
    codeTiers() {
      return this.getCodeTiers
    },
    codePec() {
      return this.getCodePec
    },
    roles(){
      return this.getRoles.reduce((x, y)=>x+", "+y)
    },
    patrimoine(){
      if (this.partenaires && this.partenaires!='[]')
        return JSON.parse(this.partenaires)
      else
        return null;
    },
    maskedCallOption:{
      get(){
        return this.getOptions.maskedNumber;
      },
      set(value){
        this.setMaskedCall(value);
      }
    }
  },
  methods: {
    ...mapActions('partenaires', ['loadPartenairesFromAPI']),
    ...mapActions('user', ['setMaskedCall']),
    time(time) {
      return timestampTranslation(time)
    }
  },
  mounted() {
    this.loadPartenairesFromAPI(this.getCodeTiers)
  },
}
</script>

<style scoped>

.box {
  word-wrap: break-word;
}

.center-margin {
  margin: 0 auto;
}

.table-user tr td:nth-child(1) {
  text-align: left;
  padding-right: 20px;
  padding-bottom: 10px;
}

</style>